import React, { FC } from 'react';
import cls from 'classnames';
import { WarningIcon } from '@stashinvest/react-assets';

import { SelectionEntryButtonProps } from './SelectionEntryButton.types';

export const classNames = {
	base: 'sds-selection-entry-button',
	isDisabled: 'is-disabled',
	hasError: 'has-error',
	isSelected: 'is-selected',
	text: 'text',
	icon: 'icon',
	assistiveMessage: 'assistive-message',
	label: 'label',
	input: 'input',
};

const SelectionEntryButton: FC<SelectionEntryButtonProps> = (props) => {
	const {
		className,
		label,
		input,
		isEnabled = true,
		assistiveMessageText,
		onClick,
		Icon,
		id,
	} = props;
	return (
		<div
			className={cls(classNames.base, className, {
				[classNames.isDisabled]: !isEnabled,
				[classNames.hasError]: isEnabled && assistiveMessageText?.type === 'error',
			})}
		>
			<button type="button" onClick={() => onClick()} id={id}>
				<div className={classNames.text}>
					{label && <div className={classNames.label}>{label}</div>}
					<div className={classNames.input}>{input}</div>
				</div>
				<div className={classNames.icon}>
					<Icon size="XS" />
				</div>
			</button>
			{isEnabled && assistiveMessageText && (
				<div className={classNames.assistiveMessage}>
					<span>
						<WarningIcon
							size="2XS"
							color={
								isEnabled && assistiveMessageText.type === 'error'
									? 'text-onErrorContainer'
									: undefined
							}
						/>
					</span>
					{assistiveMessageText.text}
				</div>
			)}
		</div>
	);
};

SelectionEntryButton.displayName = 'SelectionEntryButton';

export default SelectionEntryButton;
